import React from 'react';
import { useController, ApplicationView as view } from '@aha-app/mvc';
import CardLayoutEditorController from '../controllers/CardLayoutEditorController';

const CardPreviewHeader = () => {
  const controller = useController(CardLayoutEditorController);
  const { currentRecordLayout, currentModelClass } = controller;

  if (!currentRecordLayout.parentRecordIsAvailable) {
    return null;
  }

  switch (currentModelClass.typename) {
    case 'Feature':
      return (
        <a slot='header' href='#' onClick={event => event.preventDefault()}>
          ABC-E-123 Example epic
        </a>
      );

    case 'Requirement':
      return (
        <a slot='header' href='#' onClick={event => event.preventDefault()}>
          ABC-123 Example feature
        </a>
      );

    default:
      return null;
  }
};

export default view(CardPreviewHeader);
